define('extensions/knockout/functions/concat', [
    'knockout'
], (ko) => {
    ko.subscribable.fn.concat = function (list) {
        return ko.pureComputed(() => this().concat(ko.unwrap(list)));
    };
});